// sessions mutations
export const SET_USERNAME = "SET_USERNAME";
export const SET_PASSWORD = "SET_PASSWORD";
export const SET_USER_LOGGED_IN = "SET_USER_LOGGED_IN";
export const SET_USER_LOGGED_OUT = "SET_USER_LOGGED_OUT";
export const SET_REFRESH_TOKEN_REQUEST_ACTIVE = "SET_REFRESH_TOKEN_REQUEST_ACTIVE";
export const SET_REFRESH_TOKEN_REQUEST_INACTIVE = "SET_REFRESH_TOKEN_REQUEST_INACTIVE";

// users mutations
export const SET_USERS = "SET_USERS";
export const ADD_NEW_USER = "ADD_NEW_USER";
export const UPDATE_USER = "UPDATE_USER";
export const SET_SELECTED_USER = "SET_SELECTED_USER";

// notification mutations
export const SHOW_NOTIFICATION = "SHOW_NOTIFICATION";
export const CLOSE_NOTIFICATION = "CLOSE_NOTIFICATION";



// WEBPACK FOOTER //
// ./src/store/mutation-types.js